import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react';
import AuthDesktop from './auth.desktop';
import AuthMobile from './auth.mobile';
import useGoogleAuth from '../../_hooks/useGoogleAuth';
import { IUser } from '../../_store/types';

const Auth = ({
  open = false,
  onClose,
  onLastConfirm = () => {},
}: {
  open: boolean;
  onClose: () => void;
  onLastConfirm?: (data: IUser) => void;
}) => {
  const isDesktop = useIsDesktop();

  useGoogleAuth();

  return (
    <>
      {isDesktop ? (
        <AuthDesktop
          open={open}
          onClose={onClose}
          onLastConfirm={onLastConfirm}
        />
      ) : (
        <AuthMobile
          open={open}
          onClose={onClose}
          onLastConfirm={onLastConfirm}
        />
      )}
    </>
  );
};

export default Auth;
